// @flow strict

import * as React from 'react';

// Components
import HeaderCTA from '../../components/HeaderCta';
import FormattedContent from '../../internal/FormattedContent';
import PageContentBlock from '../../internal/PageContentBlock';
import { Columns } from '../../internal/Columns';

// Internal Component
import Stepper from './internal/Stepper';

type ChecklistPropTypes = {|
  headerTitle: string,
  headerSubTitle: string,
  headerCtaText: string,
  headerCtaHref: string,
  headerBackground: 'Featured' | 'Dark' | 'Silver' | 'Crystal',
  headerImage: string,
  pathwayIntro: string,
  pathwayDescription: string,
  stepperTitle: string,
  stepperIntro: string,
  steps: Array<string>,
  footerTitle: string,
  footerSubTitle: string,
  footerCtaText: string,
  footerCtaHref: string,
  footerBackground: 'Featured' | 'Dark' | 'Silver' | 'Crystal',
  footerImage: string,
|};

export const PathwaysChecklistTop = (props: ChecklistPropTypes) => {
  const headerProps = {
    title: props.headerTitle,
    subtitle: props.headerSubTitle,
    firstCta: {
      text: props.headerCtaText,
      href: props.headerCtaHref,
    },
    image: props.headerImage,
    background: props.headerBackground,
  };

  return (
    <>
      <HeaderCTA {...headerProps} alignment="Left" variant="Small" />
      <PageContentBlock>
        <FormattedContent>
          <h3>{props.pathwayIntro}</h3>
          <p>{props.pathwayDescription}</p>
        </FormattedContent>
      </PageContentBlock>
    </>
  );
};

export const PathwaysChecklistBottom = (props: ChecklistPropTypes) => {
  const headerBottomProps = {
    title: props.footerTitle,
    subtitle: props.footerSubTitle,
    firstCta: {
      text: props.footerCtaText,
      href: props.footerCtaHref,
    },
    image: props.footerImage,
    background: props.footerBackground,
  };
  return (
    <>
      <PageContentBlock title={props.stepperTitle} intro={props.stepperIntro}>
        <Columns columns={3}>
          {props.steps.map((step, index) => (
            <Stepper order={index + 1} message={step} />
          ))}
        </Columns>
      </PageContentBlock>
      <HeaderCTA {...headerBottomProps} variant="Small" />
    </>
  );
};
